import { useEffect } from "react";
import { addContextListener } from "@seahorse/api/fdc3";

const MAX_FDC3_LOG_ENTRIES = 50;

const IntentListnerWrapper = ({
  children,
  setContext,
  setInteropEventId,
}) => {
  useEffect(() => {
    let isDisposed = false;
    let cleanupListeners = () => {};

    const publishInteropContext = (
      nextContext,
      metadata = null,
      subscriptionType = "unknown"
    ) => {
      if (isDisposed || !nextContext) {
        return;
      }

      const nextLogEntry = {
        receivedAt: new Date().toISOString(),
        subscriptionType,
        contextType: nextContext?.type ?? null,
        ticker:
          nextContext?.instruments?.[0]?.id?.ticker ??
          nextContext?.ccyPair ??
          null,
        metadata,
        context: nextContext,
      };

      if (typeof window !== "undefined") {
        const existingLogs = Array.isArray(window.__EMALPHA_FDC3_LOGS__)
          ? window.__EMALPHA_FDC3_LOGS__
          : [];

        window.__EMALPHA_FDC3_LOGS__ = [...existingLogs, nextLogEntry].slice(
          -MAX_FDC3_LOG_ENTRIES
        );
        window.__EMALPHA_LAST_FDC3_MESSAGE__ = nextLogEntry;
      }

      console.info("[EMALPHA][FDC3] Received context", nextLogEntry);

      setContext(nextContext);
      setInteropEventId((currentEventId) => currentEventId + 1);
    };

    const initializeListeners = async () => {
      try {
        const instrumentListListener = await addContextListener(
          "fdc3.instrumentList",
          (context, metadata) => {
            publishInteropContext(context, metadata, "fdc3.instrumentList");
          }
        );

        const bestXSelectedTradeListener = await addContextListener(
          "bestx.selectedTrade",
          (context, metadata) => {
            publishInteropContext(context, metadata, "bestx.selectedTrade");
          }
        );

        cleanupListeners = () => {
          if (
            instrumentListListener &&
            typeof instrumentListListener.unsubscribe === "function"
          ) {
            instrumentListListener.unsubscribe();
          }
          if (
            bestXSelectedTradeListener &&
            typeof bestXSelectedTradeListener.unsubscribe === "function"
          ) {
            bestXSelectedTradeListener.unsubscribe();
          }
        };
      } catch (error) {
        if (!isDisposed) {
          console.error("Error setting up context listener:", error);
        }
      }
    };

    initializeListeners();
    return () => {
      isDisposed = true;
      cleanupListeners();
    };
  }, [setContext, setInteropEventId]);

  return children;
};

export default IntentListnerWrapper;
